import * as PropertyBucket from '../../Properties/Properties';
import * as httpService from '../../Components/HttpService/HttpService';

export function getQuestionListRequested() {
    return {
        type: 'GET_QUESTION_LIST_REQUESTED'
    };
}

export function getQuestionListDone(data) {
    return {
        type: 'GET_QUESTION_LIST_DONE',
        payload: data
    };
}

export function getQuestionListFailed(error) {
    return {
        type: 'GET_QUESTION_LIST_FAILED',
        payload: error
    };
}

export function getQuestionListData() {
    let url = PropertyBucket.getLists();
    return dispatch => {
        dispatch(getQuestionListRequested());
        let response = httpService.getService(url, "GET");
        response.then(data => {
            dispatch(getQuestionListDone(data));
        })
            .catch(error => {
                dispatch(getQuestionListFailed(error));
            })
    }
}


export const GET_QUESTION_LIST_DATA_REQUESTED = 'GET_QUESTION_LIST_REQUESTED';
export const GET_QUESTION_LIST_DATA_DONE = 'GET_QUESTION_LIST_DONE';
export const GET_QUESTION_LIST_DATA_FAILED = 'GET_QUESTION_LIST_FAILED';

